import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import StandaloneIcon from '@tds/core-standalone-icon';
import Notification from '@tds/core-notification';
import Tooltip from '@tds/core-tooltip';
import Text from '@tds/core-text';
import { Table, Tbody, Tr, Td } from 'react-super-responsive-table';

import request from '../utils/request';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

import { SearchWrapper, TableWrapper } from './css';

const EditableSalesRepInfo = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      LIST: { searchLabelTitle, searchHintTitle }
    },
    editableSalesRepInfo: {
      selectLabel,
      enterUserError,
      noRecordFoundError,
      toolTip
    }
  } = localizedStrings;

  const [querySrting, setQueryString] = useState();
  const [userList, setUserList] = useState([]);
  const [userSelected, setUserSelected] = useState();
  const [errorMessage, setErrorMessage] = useState();

  useEffect(() => {
    localStorage.removeItem('salesRepInfoForSRT');
    return () => {
      localStorage.removeItem('salesRepInfoForSRT');
    };
  }, []);

  const clearSearch = () => {
    setQueryString('');
    setUserList([]);
  };

  const onUserSelect = userInfo => {
    setUserSelected(userInfo);
    localStorage.setItem('salesRepInfoForSRT', JSON.stringify(userInfo));
    clearSearch();
  };

  const onUnSelectUser = () => {
    localStorage.removeItem('salesRepInfoForSRT');
  };

  const setQuery = e => {
    setQueryString(e.target.value);
  };

  const getUsers = () => {
    if (!querySrting) {
      setErrorMessage(enterUserError);
      setUserList([]);
      return;
    }

    request.get(`/users/for-srt-group?q=${querySrting}`).then(response => {
      const responseData = response.data.users;
      if (responseData.length === 0) {
        setErrorMessage(noRecordFoundError);
        return;
      }
      const users = response.data.users.map(user => {
        return {
          ...user,
          name: `${user.first_name} ${user.last_name}`,
          channelName: _.get(user, 'channels.0.name', '')
        };
      });
      setUserList(users);
      setErrorMessage('');
    });
  };

  return (
    <>
      <SearchWrapper>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', alignItem: 'center' }}>
            <div>
              <p style={{ fontSize: '14px', fontWeight: '700' }}>
                {searchLabelTitle}
              </p>
              <p style={{ fontSize: '14px' }}>{searchHintTitle}</p>
            </div>
            <div style={{ margin: '1rem 0 0 1rem' }}>
              <Tooltip copy="en">{toolTip}</Tooltip>
            </div>
          </div>
          <div style={{ display: 'flex', position: 'relative' }}>
            <input
              style={{ width: '350px', height: '51px', marginTop: '0.5rem' }}
              type="text"
              value={querySrting}
              onChange={setQuery}
              onKeyDown={e => {
                if (e.key === 'Enter') getUsers();
              }}
            />
            {querySrting && (
              <button
                type="button"
                style={{
                  background: 'transparent',
                  position: 'absolute',
                  height: '30px',
                  width: '30px',
                  right: '65px',
                  top: '19px',
                  borderRadius: '25px',
                  border: '1px solid #555',
                  color: '#555'
                }}
                onClick={clearSearch}
              >
                x
              </button>
            )}

            <button
              type="button"
              style={{
                background: ' rgb(69, 44, 106)',
                padding: '0.4rem 1rem',
                height: '51px',
                width: '50px',
                border: 0,
                marginTop: '8px',
                marginLeft: '-4px',
                borderRadius: '0 5px 5px 0'
              }}
              onClick={getUsers}
            >
              <StandaloneIcon
                symbol="spyglass"
                size={24}
                a11yText="Search this site."
                variant="inverted"
              />
            </button>
          </div>
        </div>
      </SearchWrapper>
      {errorMessage && (
        <Notification variant="error" copy="en">
          {errorMessage}
        </Notification>
      )}
      {!errorMessage && userList.length > 0 && (
        <TableWrapper>
          <Table>
            <Tbody>
              {userList.map((user, index) => (
                <Tr
                  key={user.id}
                  style={{
                    background: index % 2 === 0 ? '#f9f1ff' : '#ffffff'
                  }}
                >
                  <Td>{user.name}</Td>
                  <Td>{user.email}</Td>
                  <Td>
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() => onUserSelect(user)}
                    >
                      {selectLabel}
                    </button>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableWrapper>
      )}
      {userList.length === 0 && userSelected && (
        <div
          style={{
            width: 'fit-content',
            padding: '0 1rem',
            background: '#f2eff4'
          }}
        >
          <Notification
            variant="branded"
            copy="en"
            dismissible
            onDismiss={onUnSelectUser}
          >
            <Text>Order will be created on behalf of </Text>
            <Text bold>{userSelected.name}</Text>
          </Notification>
        </div>
      )}
    </>
  );
};

export default EditableSalesRepInfo;
